import {
  Component,
  forwardRef,
  Inject,
  Input
}                             from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }   from '@ngx-translate/core';

import { DvlaLookupMotHistoryExpandedRowComponent } from './dvla-lookup.mot-history.row.expanded.component';
import { DvlaLookupMotHistoryModel }                from './models/dvla-lookup.mot-history';
import { DvlaLookupMotHistoryResponseModel }        from './models/dvla.mot-history.response';
import { DvlaLookupService }                        from './dvla-lookup.service';
import { ExpanderComponent }                        from '../table/cell-components/actions/expander.component';
import { MessagesService }                          from '../messages/messages.service';
import { Table }                                    from '../table/types/table';
import { VehicleModel }                             from '../vehicles/models/vehicle';

@Component({
  selector   : 'wor-dvla-lookup-mot-history',
  template: require('./dvla-lookup.mot-history.component.html'),
  styles: [ require('./dvla-lookup.mot-history.component.scss') ]
})
export class DvlaLookupMotHistoryComponent {

  public tableSettings : Table = {
    columns: [
      {
        field : 'test_date',
        header: {
          text: this.translateService.instant('VEHICLE_SPACE.VEHICLE_MOT_HISTORY.TEST_DATE')
        }
      },
      {
        classes: [ 'text-center'],
        field  : 'test_result',
        header : {
          classes: [ 'text-center'],
          text   : this.translateService.instant('VEHICLE_SPACE.VEHICLE_MOT_HISTORY.RESULT')
        }
      },
      {
        field : 'expiry_date',
        header: {
          text: this.translateService.instant('VEHICLE_SPACE.VEHICLE_MOT_HISTORY.EXPIRY_DATE')
        }
      },
      {
        classes: [ 'text-center'],
        field  : 'odometer_reading',
        header : {
          classes: [ 'text-center'],
          text   : this.translateService.instant('VEHICLE_SPACE.ODOMETER')
        }
      },
      {
        field : 'mot_test_number',
        header: {
          text: this.translateService.instant('VEHICLE_SPACE.VEHICLE_MOT_HISTORY.TEST_NUMBER')
        }
      },
      {
        component: {
          bindings: {
            inputs: {
              isExpandable: ( row : DvlaLookupMotHistoryModel ) => this.recordHasItems(row),
            }
          },
          enabled: true,
          factory: ExpanderComponent,
        },
        sortable: false
      }
    ],
    pagination: {
      enabled: false
    },
    rows: {
      expand: {
        enabled     : true,
        factory     : DvlaLookupMotHistoryExpandedRowComponent,
        isExpandable: ( row : DvlaLookupMotHistoryModel ) => this.recordHasItems(row)
      },
      highlight: {
        enabled: true
      }
    },
  };

  @BlockUI('dvlaLookupMotHistoryBlock') block : NgBlockUI;

  @Input() history : DvlaLookupMotHistoryResponseModel;
  @Input() vehicle : VehicleModel;

  constructor (
    public activeModal       : NgbActiveModal,
    @Inject(forwardRef(() => DvlaLookupService))
    private dvlaLookupService: DvlaLookupService,
    private messagesService  : MessagesService,
    public translateService  : TranslateService
  ) { }

  recordHasItems ( record : DvlaLookupMotHistoryModel ) : boolean {
    return !!record?.history_items?.length;
  }

  refresh () {
    this.block.start();

    this.dvlaLookupService.updateMotHistory(this.vehicle)
    .then(( history : DvlaLookupMotHistoryResponseModel ) => {
      this.messagesService.show(this.translateService.instant('GENERAL_SPACE.MESSAGE.UPDATE_MOT_HISTORY'), 'success');

      this.history = history;
    })
    .catch(( err : any )=>{
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}



